import type { NavigateFunction } from 'react-router-dom';

/** Returns the parent tab path for deep routes that can be opened without back-stack. */
export function getDeepRouteParentTab(pathname: string): string | null {
  if (pathname === '/messages/new' || pathname.startsWith('/messages/')) return '/messages';
  if (pathname === '/contacts/add' || pathname === '/contacts/invite' || pathname.startsWith('/contacts/')) return '/contacts';
  if (pathname === '/calls') return '/contacts';
  if (pathname.startsWith('/servers/')) return '/servers';
  if (pathname.startsWith('/settings/')) return '/settings';
  if (pathname === '/keys' || pathname === '/import') return '/settings';
  return null;
}

function getBrowserRouterHistoryIndex(): number | null {
  const state = window.history.state as { idx?: unknown } | null;
  return typeof state?.idx === 'number' ? state.idx : null;
}

export function canNavigateBackInApp(): boolean {
  const index = getBrowserRouterHistoryIndex();
  if (index !== null) return index > 0;
  return window.history.length > 1;
}

export function navigateBackOrFallback(navigate: NavigateFunction, fallbackPath: string): void {
  if (canNavigateBackInApp()) {
    navigate(-1);
    return;
  }

  navigate(fallbackPath, { replace: true });
}
